import { Spinner } from 'react-bootstrap'

const Loading = () => {

    return <Spinner />
    
}

export default Loading